exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button:focus{outline:none}._2bWBG{width:100%;height:100%;padding:20px 30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column;min-height:100vh}._2bWBG>svg{opacity:.5}._2bWBG>div{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}._2bWBG>div:first-child{margin-right:50px}._2bWBG p{color:#878787;font-size:25px;margin-bottom:10px}._2bWBG button{color:#4e4dae;background-color:transparent;font-size:20px;font-weight:600;cursor:pointer;margin-top:10px}._2bWBG button>span{margin-right:5px}._2bWBG button:hover{color:#878787}", ""]);

// exports
exports.locals = {
	"notFound": "_2bWBG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/routes/not-found/NotFound.css
// module id = 749
// module chunks = 6